var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},_vm._l((_vm.dashboardData),function(value,name,index){return _c('div',{key:index,staticClass:"dash-list"},[_c('span',{staticClass:"key"},[_vm._v(_vm._s(value.label))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(value.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }